export default __webpack_public_path__ + "static/4-d8fa533346f010038317f07c1adc7d6f.jpeg";